import Colors from '@/constants/Colors';
import styled from 'styled-components';

export const StyledSummary = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: white;

  .results {
    height: 100%;
    border-radius: 8px;
    padding: 20px 20px 40px 20px;
    display: flex;
    flex-direction: column;

    .results-header {
      display: flex;
      justify-content: space-between;

      .title-and-number {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .progress-bar {
          .ant-progress-outer {
            width: 96%;
          }
        }
      }

      .buttons {
        flex: 1;
        display: flex;
        justify-content: flex-end;
      }
    }

    .questions-container {
      flex: 1;
      height: 0;
      padding: 15px 0px;
      overflow-y: auto;

      .questions {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 20px;
      }
    }
  }
`;
